'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var react = require('@chakra-ui/react');
var AccordionItem = require('./AccordionItem.js');
var utils = require('@chakra-ui/utils');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * AccordionButton
 *
 * Eexpands and collapses an accordion item. It must be a child of `AccordionItem`.
 *
 * Note 🚨: Each accordion button must be wrapped in an <AccordionHeading />
 * that is appropriate for the information architecture of the page.
 */
var AccordionButton = react.forwardRef(function (props, ref) {
  var _useAccordionItemCont = AccordionItem.useAccordionItemContext(),
    getButtonProps = _useAccordionItemCont.getButtonProps;
  var buttonProps = getButtonProps(props, ref);
  var styles = react.useStyles();
  var buttonStyles = _objectSpread({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    outline: 0
  }, styles.button);
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.button, _extends__default["default"]({}, buttonProps, {
    className: utils.cx('chakra-accordion__button', props.className),
    __css: buttonStyles
  }));
});
AccordionButton.displayName = 'AccordionButton';
exports.AccordionButton = AccordionButton;